// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_2GrtZuYT","checkboxBox":"D3yrGgj0","checkboxIcon":"_3a7B4nUn","fullWidth":"wz83ucsG","checkboxLabel":"_320E8AoM"};